var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDribbleGrey = function SvgDribbleGrey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dribble-grey-logo",
    transform: "translate(-2.5 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M2.5,11.5c.5,12,17.509,12,18,0C20.008-.5,2.994-.5,2.5,11.5Z",
    transform: "translate(0 0)",
    fill: "#7c98b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M18.191,15.54a18.866,18.866,0,0,1,5.649.262,8.1,8.1,0,0,0-1.828-5.071,10.83,10.83,0,0,1-4.53,3.209C17.739,14.461,17.974,15,18.191,15.54Zm3.014-5.7a8.045,8.045,0,0,0-5.379-2.053,8.482,8.482,0,0,0-1.9.229,43.821,43.821,0,0,1,3.027,4.762A9.127,9.127,0,0,0,21.205,9.841Zm-5.695,3.43A51.575,51.575,0,0,0,12.5,8.564a8.17,8.17,0,0,0-4.492,5.7A30.385,30.385,0,0,0,15.51,13.271Zm.947,2.579c.1-.034.21-.067.319-.1-.2-.458-.423-.92-.654-1.37a29.841,29.841,0,0,1-8.278,1.151A8.054,8.054,0,0,0,9.91,21.179,12.783,12.783,0,0,1,16.457,15.85Zm.765,1.251a10.794,10.794,0,0,0-6.167,4.92,7.889,7.889,0,0,0,7.892,1.037,32.861,32.861,0,0,0-1.677-5.974A.328.328,0,0,1,17.222,17.1Zm1.606-.4a35.154,35.154,0,0,1,1.536,5.641,7.948,7.948,0,0,0,3.38-5.3A11.571,11.571,0,0,0,18.828,16.7Z",
    transform: "translate(-4.328 -4.286)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDribbleGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dribble-grey.f65a5728.svg";
export { ForwardRef as ReactComponent };